import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getAllDocuments } from "../../../actions/mis.action";
import { DocumentCard } from "./DocumentCard";
import { isValidArray } from "../../../helper";
import Pagination from "../../Pagination";
import { isEmpty } from "lodash";
import { Search } from "../../reusableComponent/search";
import { getSearchedResult } from "./documents.selector";
import NoDataFound from "../../../component/NoDataFound";

class Documents extends Component {
  constructor(props) {
    super(props);
    this.entriesPerPage = 51;
    this.state = {
      minRange: 0,
      offset: 0,
      maxRange: this.entriesPerPage,
      searchText: ""
    };
  }

  componentDidMount() {
    const { getAllDocuments } = this.props;
    getAllDocuments();
  }

  onPageChange = pageNumber => {
    this.setState({ offset: pageNumber.selected, ...pageNumber });
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth"
    });
  };

  searchDocument = e => {
    this.setState({
      searchText: e.target.value.trim(),
      minRange: 0,
      offset: 0,
      maxRange: this.entriesPerPage
    });
  };

  render() {
    const { documentsList } = this.props;
    const { minRange, offset, maxRange, searchText } = this.state;
    let searchedDocList = getSearchedResult(documentsList, searchText);
    let lastLimit =
      minRange + this.entriesPerPage > searchedDocList.length
        ? searchedDocList.length
        : minRange + this.entriesPerPage;

    return (
      <div className="documents_container">
        <div className="header-wrapper">
          <h3 className="header">Attachments</h3>
          <div>
            {documentsList && documentsList.length ? (
              <Search
                placeholder="Search"
                keyName="searchText"
                onChange={this.searchDocument}
              />
            ) : null}
          </div>
        </div>
        <div className="document-list-wrapper">
          {searchedDocList && searchedDocList.length ? (
            searchedDocList.map((documentDetails, index) => {
              if (minRange <= index && index < maxRange) {
                return (
                  documentDetails && (
                    <DocumentCard
                      documentDetails={documentDetails}
                      id={index}
                    />
                  )
                );
              }
            })
          ) : (
            <NoDataFound />
          )}
        </div>
        <div className="doc-pagination">
          {isValidArray(searchedDocList) &&
          searchedDocList.length > this.entriesPerPage ? (
            <div className="pagination-wrapper">
              <div className="total-entries">
                Showing{" "}
                <b>
                  {minRange + 1} to {lastLimit} of {searchedDocList.length}{" "}
                </b>
                Entries
              </div>

              <div className="pagination">
                <Pagination
                  limit={this.entriesPerPage}
                  pageCount={Math.ceil(
                    searchedDocList.length / this.entriesPerPage
                  )}
                  onPageChange={this.onPageChange}
                  offset={offset}
                />
              </div>
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    documentsList: state.misReducer.documentsList || []
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getAllDocuments
    },
    dispatch
  );
}

const DocumentsComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(Documents);
export { DocumentsComponent };
